import { TriangleAlert } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@axilon-apps/libs-ui-shadcn'

interface Props {
  isOpen: boolean
  confirm: () => void
  close: () => void
  title?: string
  description: string
  confirmButton: string
}

const ConfirmModal = ({
  isOpen,
  confirm,
  close,
  title = 'Confirmation',
  description,
  confirmButton
}: Props) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={(next) => (next ? null : close())}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <TriangleAlert className="text-st-warn size-4" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={close}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            // `e.preventDefault()` blocks Radix's default close-on-action so
            // the caller's `confirm` callback owns the close lifecycle. This
            // matters for flows that transition from this confirm step into
            // a follow-up dialog rendered by the SAME parent — e.g. password
            // reset (Confirm → SecretModal showing the new password). Letting
            // Radix fire `onOpenChange(false)` propagates `close()` up to
            // the parent, which unmounts the entire flow before the next
            // phase can render. Consumers that DO want the modal to close
            // (the `useConfirmModal` hook, `MfaEnabledCard`) already call
            // `close()` explicitly inside their `onConfirm`, so the
            // controlled `open` prop drops to false on the next render and
            // Radix closes naturally.
            onClick={(e) => {
              e.preventDefault()
              confirm()
            }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {confirmButton}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default ConfirmModal
